export default __webpack_public_path__ + "static/media/info.2f61e690.svg";